jQuery(document).ready(function ($) {
    'use strict';

    $(document.body).on('click', '.lang-toggle', function() {
        $('.country-selector').toggle();
        $('body').toggleClass('lang-open');
    });

    $('body').click(function(e) {
        if ($('body').hasClass('lang-open')) {
            var target = $(e.target);
            if(!target.is('.lang-toggle') && !target.is('.country-selector')) {
                $('.country-selector').hide();
                $('body').removeClass('lang-open');
            }
        }

    });

    $(window).scroll(function() {
        if ($('body').hasClass('lang-open')) {
            $('.country-selector').hide();
            $('body').removeClass('lang-open');
        }
    });

});
//# sourceMappingURL=country-select.js.map
